import { render, staticRenderFns } from "./importmarketingTarget.vue?vue&type=template&id=c4371bec&scoped=true"
import script from "./importmarketingTarget.vue?vue&type=script&lang=js"
export * from "./importmarketingTarget.vue?vue&type=script&lang=js"
import style0 from "./importmarketingTarget.vue?vue&type=style&index=0&id=c4371bec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4371bec",
  null
  
)

export default component.exports